import {type KeyboardEventHandler, memo, useCallback} from 'react'

import {BaseProjectViewFilterInput} from '../../../components/filter-bar/base-project-view-filter-input'
import {useSearch} from '../../../components/filter-bar/search-context'
import {shortcutFromEvent, SHORTCUTS} from '../../../helpers/keyboard-shortcuts'
import {ROADMAP_FILTER_INPUT_Z_INDEX} from '../roadmap-z-index'

const containerSx = {
  zIndex: `${ROADMAP_FILTER_INPUT_Z_INDEX}`,
  boxShadow: 'unset',
  borderBottom: '1px solid',
  borderBottomColor: 'border.muted',
}
export const RoadmapFilterInput = memo(function RoadmapFilterInput({filterCount}: {filterCount: number}) {
  const {searchInputRef, searchToggleButtonRef} = useSearch()
  const dispatchInputFocus = useCallback(() => {
    searchInputRef.current?.focus()
  }, [searchInputRef])

  const onInputKeyDown: KeyboardEventHandler = useCallback(
    e => {
      switch (shortcutFromEvent(e)) {
        case SHORTCUTS.ESCAPE:
          searchToggleButtonRef.current?.focus()
          return
      }
    },
    [searchToggleButtonRef],
  )

  return (
    <BaseProjectViewFilterInput
      containerSx={containerSx}
      onInputKeyDown={onInputKeyDown}
      dispatchInputFocusEvent={dispatchInputFocus}
      filterCount={filterCount}
    />
  )
})

try{ RoadmapFilterInput.displayName ||= 'RoadmapFilterInput' } catch {}